import { Outlet } from 'react-router-dom'
import { DashboardContainer } from '../Dashboard'
import { SideNav } from './SideNav'

const Settings = () => {
   return (
      <>
         <DashboardContainer>
            <div className="flex gap-5 mt-5">
               <div className="flex flex-1 gap-5 overflow-hidden bg-primary/10 rounded-xl max-w-[1100px] max-h-[calc(100vh-110px)] min-h-[calc(100vh-110px)] overflow-y-auto">
                  <SideNav />
                  <Outlet />
               </div>
            </div>
         </DashboardContainer>
      </>
   )
}

export default Settings
